<template>
  <div v-if="data">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="margin-top-50"></div>
          <div class="header-wrapper">
            <h1 class="text-primary-fh left-header" v-html="data.familytree.sendinviteHeader"></h1>
          </div>
          <p class="text-dark" v-html="data.familytree.sendinviteDisclaimerText"></p>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div v-for="(sr, i) in selectedRelatives" :key="i">
            <div class="card">
              <div class="card-body text-left">
                <h6 class="card-title text-primary-fh" v-text="sr.firstName + ' ' + sr.lastName"></h6>
                <h6 class="text-dark cursor-pointer" data-toggle="collapse" :data-target="'#card-' + i" >
                  Kontaktsätt
                </h6>
                <div class="collapse" v-bind:id="'card-' + i">
                  <input
                    type="text"
                    step="1"
                    min="1"
                    max="200"
                    class="form-control form-control-lg"
                    :class="((sr.emailAddress && sr.emailAddress.length > 0) && !validEmail(sr.emailAddress)) ? 'invalid' : ''"
                    v-model="sr.emailAddress"
                    placeholder="E-post"
                  />
                  <div class="margin-6"></div>
                  <input
                    type="number"
                    class="form-control form-control-lg"
                    v-model="sr.phoneNumber"
                    maxlength="10"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    placeholder="SMS"
                  />
                  <small>Ange e-postadress och/eller telefonnummer för SMS</small>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        <div class="clearfix"></div>
        <div class="card">
          <div class="card-body text-left">
            <div class="clearfix"></div>
            <h6 class="text-dark">Förhandsvisning av meddelandet:</h6>
            <div class="card override-card">
              <div class="card-body override-card-body text-left">
                <p v-html="data.familytree.topPreviewText.replace('{fullName}', fullname + ':')"></p>
                <hr />
                <p v-text="personalMessage"></p>
                <p v-if="personalMessage.length < 1"><i class="text-muted">Ditt personliga meddelande..</i></p>
                <hr />
                <p v-html="data.familytree.bottomPreviewText.replace('{invitationLink}', '[Länk kommer här]')"></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <button
            class="btn btn-primary btn-lg btn-block"
            :disabled="dirty"
            @click="sendInvites()">
            Skicka inbjudningsmeddelande
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
          <div class="clearfix"></div>
          <small>Fyll i e-postadress eller telefonnummer för att skicka meddelandet.</small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <div class="clearfix"></div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'familytreesendinvite',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      dirty: true,
      personalMessage: '',
      fullname: '',
      invitationLink: '',
      chosenMethods: [],
      selectedRelatives: []
    }
  },
  methods: {
    enforceNumbers (number) {
      number = number.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    sendInvites () {
      const r = confirm('Är du säker på att du vill skicka inbjudningsmeddelande? Kontrollera så att kontaktsätt stämmer.')
      if (r) {
        let loader = this.$loading.show()
        var invites = []

        this.selectedRelatives.forEach(sr => {
          const inv = {
            inviteeId: sr.inviteeId,
            emailAddress: sr.emailAddress,
            phoneNumber: sr.phoneNumber,
            invitationLink: sr.invitationLink,
            geneNegative: sessionStorage.getItem('geneNegative') === 'true'
          }
          invites.push(inv)
        })
        const invitationMessage =
          this.data.familytree.topPreviewText.replace('{fullName}', this.fullname + ':') +
          '\n\n' + this.personalMessage + '\n\n' + this.data.familytree.bottomPreviewText

        axios.patchInvites(config.relativeUri, invites, invitationMessage).then((response) => {
          if (response) {
            loader.hide()
            sessionStorage.removeItem('personalMessage')
            sessionStorage.removeItem('invitationLink')
            sessionStorage.removeItem('selectedRelatives')
            this.$router.push('/familytree')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  computed: {},
  watch: {
    selectedRelatives: {
      handler (sr) {
        for (var i = 0; i < sr.length; i += 1) {
          if ((sr[i].emailAddress === null || sr[i].emailAddress === '' || !this.validEmail(sr[i].emailAddress)) &&
            (sr[i].phoneNumber === null || sr[i].phoneNumber === '' || sr[i].phoneNumber.length < 9)) {
            this.dirty = true
            break
          } else {
            this.dirty = false
          }
        }
      },
      deep: true
    }
  },
  beforeMount () {
    if (localStorage.getItem('selectedRelatives')) {
      this.selectedRelatives = JSON.parse(localStorage.getItem('selectedRelatives'))
    }
    if (sessionStorage.getItem('fullname')) {
      this.fullname = sessionStorage.getItem('fullname')
    }
    if (sessionStorage.getItem('personalMessage')) {
      this.personalMessage = sessionStorage.getItem('personalMessage')
    }
    if (sessionStorage.getItem('invitationLink')) {
      this.invitationLink = sessionStorage.getItem('invitationLink')
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          familytree {
            inviteheader
            inviteInfoText
            topPreviewText
            bottomPreviewText
            sendinviteHeader
            sendinviteDisclaimerText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.container {
  margin-top: 75px;
}
.margin-top-50 {
  margin-top: 50px;
}
.header-wrapper {
  display: flex;
}
.text-left {
  text-align: left;
}
.invalid {
  border: 2px solid red;
}
.card {
  border: 2px solid #bae2ef;
  border-radius: 15px;
  margin-top: 2rem;
}
.card [data-toggle="collapse"]:after {
  display: inline-block;
  font-size: inherit;
  content: "\25BC";
  transform: rotate(0deg);
  transition: all linear 0.25s;
}
.card [data-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(180deg) ;
}
.card-body {
  background: #e5f1f5;
  border-radius: 15px;
}
.override-card {
  margin-top: 1vh;
  border-radius: 0;
  border: 2px solid #c7c7c7;
}
.override-card-body {
  border-radius: 0;
  background: #ebebeb;
  color: #4e4e4e;
}
.margin-6 {
  margin: 6px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FamilyTreeSendInvite.vue